import { saveAs } from "file-saver";
// @ts-expect-error – save-svg-as-png has no type declarations
import { svgAsPngUri } from "save-svg-as-png";

const jsonToCsv = (json: Record<string, unknown>[]) => {
  const keys = Object.keys(json[0]);
  const csvRows = json.map((row: Record<string, unknown>) =>
    keys.map((key) => row[key]).join(","),
  );
  return [keys.join(","), ...csvRows].join("\n");
};

export const downloadZip = async (
  data: Record<string, unknown>,
  name: string | undefined,
  selector: string | undefined,
  subjectId: string | undefined,
) => {
  const date = new Date();
  const formattedDate = date.toISOString().split("T")[0].replace(/-/g, "");

  // jszip is ~100KB and only ever runs on an export click, so it stays out of
  // the entry chunk.
  const { default: JSZip } = await import("jszip");
  const zip = new JSZip();
  const svgElements = document.querySelectorAll(`svg.${selector}`);
  /* eslint-disable-next-line @typescript-eslint/no-unused-vars -- TODO(eslint-baseline): address @typescript-eslint/no-unused-vars */
  const promises = Array.from(svgElements).map((svg, index) => {
    return svgAsPngUri(svg, {
      backgroundColor: "white",

      fonts: [
        {
          url: "/fonts/WorkSans-Regular.ttf",
          text: `@font-face {
    font-family: "Work Sans";
    font-style: normal;
    font-weight: 400;
    font-display: swap;
    src: url("/fonts/WorkSans-Regular.ttf") format("truetype");
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
  }`,
        },
      ],
    }).then((uri: string) => {
      const data = uri.split(",")[1];
      const plotName = svg.getAttribute("id")?.split(` ${selector}`)[0];
      zip.file(
        `${formattedDate}_${name}_${plotName?.toLowerCase()}.png`,
        data,
        {
          base64: true,
        },
      );
    });
  });

  if (Object.keys(data)[0] !== "0") {
    Object.keys(data).forEach((key) => {
      zip.file(
        subjectId
          ? formattedDate + "_" + key + "_" + subjectId + ".csv"
          : formattedDate + "_" + key + ".csv",
        jsonToCsv(
          Array.isArray(data[key])
            ? (data[key] as Record<string, unknown>[])
            : [data[key] as Record<string, unknown>],
        ),
      );
    });
  } else {
    const csvString = jsonToCsv(
      Array.isArray(data)
        ? (data as Record<string, unknown>[])
        : [data as Record<string, unknown>],
    );
    zip.file(
      subjectId
        ? formattedDate + "_" + name + "_" + subjectId + ".csv"
        : formattedDate + "_" + name + ".csv",
      csvString,
    );
  }

  await Promise.all(promises);

  zip.generateAsync({ type: "blob" }).then((content) => {
    saveAs(
      content,
      subjectId
        ? formattedDate + "_" + name + "_" + subjectId + ".zip"
        : formattedDate + "_" + name + ".zip",
    );
  });
};
